module.exports = __webpack_public_path__ + "static/frankmariaweb.cf2242d6.jpg";